import {createSelector} from '@ngrx/store';
import * as fromRouter from '../../../core/store';

export * from './products/products.selectors';
export * from './brand-info/brand-info.selector';

export const getFiltersParam = createSelector(
  fromRouter.getQueryParams,
  (query: { [key: string]: any }) => query && query.filter
);

export * from './sort/sort.selectors';
